module.exports = __webpack_public_path__ + "static/media/PolarisLogoMob.578b2bf0.svg";